/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const o=[1,2],t=[1,2,3,4];export{o as flowParticleTypes,t as flowParticleVertexIds};
